import { client } from '../../../shared/services/apiClient';

export const signIn = async (data: string): Promise<any> => {
  return client(false, false, true).post<any>('/auth/login', data);
};
